import Api from 'client/api/v2/Api';
import axios from 'axios';

class GoogleMdmApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2/google-emm';
  }

  async getEnterprise() {
    const url = `${this.baseUrl}/enterprises`;
    await this.initialize();
    const resp = await axios.get(url);
    return resp.data;
  }

  /**
   * @param {Object} payload - Request Body
   */
  async postEnterprise(payload) {
    const url = `${this.baseUrl}/enterprises`;
    await this.initialize();
    const resp = await axios.post(url, payload);
    return resp.data;
  }

  /**
   * @param {string} enterpriseId - Enterprise ID
   * @param {Object} payload - Request Body
   */
  async updateEnterprise(enterpriseId, payload) {
    const url = `${this.baseUrl}/enterprises/${enterpriseId}`;
    await this.initialize();
    const resp = await axios.patch(url, payload);
    return resp.data;
  }

  /**
   * @param {string} enterpriseId - Enterprise ID
   */
  async deleteEnterprise(enterpriseId) {
    const url = `${this.baseUrl}/enterprises/${enterpriseId}`;
    await this.initialize();
    const resp = await axios.delete(url);
    return resp;
  }

  async getSignUpUrl() {
    const url = `${this.baseUrl}/signup-urls`;
    const options = {
      headers: { 'content-type': 'application/json' },
    };
    await this.initialize();
    const resp = await axios.post(url, options);
    return resp.data;
  }

  /**
   * @param {Object} payload - Request Body
   */
  async getQRLink(payload) {
    const url = `${this.baseUrl}/enrollment-tokens`;
    await this.initialize();
    const resp = await axios.post(url, payload);
    return resp.data;
  }

  /**
   * @param {string} deviceId - Device ID
   */
  async getDeviceDetails(deviceId) {
    const url = `${this.baseUrl}/devices/${deviceId}`;
    await this.initialize();
    const resp = await axios.get(url);
    return resp.data;
  }

  /**
   * @param {string} deviceId - Device ID
   */
  async getPolicyResults(deviceId) {
    const url = `${this.baseUrl}/devices/${deviceId}/policy_results`;
    await this.initialize();
    const resp = await axios.get(url);
    return resp.data;
  }

  /**
   * @param {string} deviceId - Device ID
   */
  async postLockDevice(deviceId) {
    const url = `${this.baseUrl}/devices/${deviceId}/lock`;
    const options = {
      headers: { 'content-type': 'application/json' },
    };
    await this.initialize();
    const resp = await axios.post(url, options);
    return resp;
  }

  /**
   * @param {string} deviceId - Device ID
   */
  async postEraseDevice(deviceId) {
    const url = `${this.baseUrl}/devices/${deviceId}/relinquishownership`;
    const options = {
      headers: { 'content-type': 'application/json' },
    };
    await this.initialize();
    const resp = await axios.post(url, options);
    return resp;
  }

  /**
   * @param {string} deviceId - Device ID
   * @param {Object} payload - Pin code
   */
  async postResetPasscode(deviceId, payload) {
    const url = `${this.baseUrl}/devices/${deviceId}/resetpassword`;
    /* const options = {
      headers: { 'content-type': 'application/json' },
    }; */
    await this.initialize();
    const resp = await axios.post(url, payload);
    return resp;
  }

  /**
   * @param {Object} payload - Request Body
   */
  async getWebToken(payload) {
    const url = `${this.baseUrl}/web-tokens`;
    await this.initialize();
    const resp = await axios.post(url, payload);
    return resp.data;
  }
}

export default new GoogleMdmApi();
